/* global */
// BEGIN VENDOR ASSETS
// Import theme specific vendor assets here, this should be a rare case
// END VENDOR ASSETS

// BEGIN INDIVIDUAL COMPONENT SCRIPTS
// NOTE: If your component does not need specific script functiionality there
// is no need to include the default scripts from the component starter

// import '../../components/component-menu/src/scripts/_base.js'

// END INDIVIDUAL COMPONENT SCRIPTS

(($) => {
  window.COMPONENTSCHILD || (window.COMPONENTSCHILD = {})

  COMPONENTSCHILD.init = () => {
    console.log('HELLO FROM COMPONENTS CHILD THEME')

    // Specials
    const specials = $('#specials')

    $('[data-ecs-components-control="banner-toggle"').click(function (event) {
      event.preventDefault()
      setTimeout(setDrawerHeight, 300)
    })

    $('[data-control="specials"]').click(function (event) {
      event.preventDefault()

      activeSpecials = true
      specials.fadeIn()

      if (activeMenu) {
        $toggle.trigger('click')
      }
    })

    $('[data-control="specials-close"]').click(function (event) {
      event.preventDefault()
      activeSpecials = false
      specials.fadeOut()
    })
    // End Specials

    const $corporateDrawer = $('[data-element="corporate-drawer"]')

    let $headHeight = $('.header').height()
    let $headWithNotification = ($('.ecs_components__notification').height() + $('.ecs_header').height())

    function closeAllMenus ($exclude) {
      if ($exclude !== $corporateDrawer) {
        $corporateDrawer.addClass('closed')
        $('.ecs_main_menu_button').removeClass('open')
        $('[data-control="corporate-menu"]').removeClass('open')
      }

      if ($exclude == null) {
        $('html').removeClass('ecs_menu_open')
      }
    }

    function setDrawerHeight () {
      let $headWithNotification = ($('.ecs_components__notification').height() + $('.ecs_header').height())

      $corporateDrawer.css('max-height', 'calc(100dvh - ' + $headWithNotification + 'px)')
    }

    // Toggle mobile menu
    function toggleCorporateMenu () {
      $('html').toggleClass('ecs_menu_open')
      closeAllMenus($corporateDrawer) // close all the currently open menus
      $corporateDrawer.toggleClass('closed')
      $('[data-control="corporate-menu"]').addClass('open')
      setDrawerHeight()
    }

    $('[data-control="corporate-menu"]').click(toggleCorporateMenu)

    // Change Get Directions - input placeholder and submit button
    $('input.get-directions__origin').attr('placeholder', 'Enter Starting Address')
    $('form.get-directions').addClass('icon sif-pointer-right-bold')
  }

  $(document).ready(() => {
    COMPONENTSCHILD.init()
  })
}
)(jQuery)
